<div [ngStyle]="{ width: textEllipsis }">
  <section outsideClick (outsideClick)="onClickOutside($event)">
    <ul [hidden]="!listOpen">
      <li
        *ngFor="let option of options; let optionIndex = index"
        (click)="selectOption(option, optionIndex)"
        [ngClass]="{
          selected: option.selected,
          'skip-option-disabled': isBroadcastPresetSkipBlocked(option)
        }"
      >
        <i [ngClass]="{ multiple: multiple }">
          <svg viewBox="0 0 21.02 14.02">
            <path
              fill-rule="evenodd"
              d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
            />
          </svg>
        </i>
        <span class="show-title">
          {{ option["name"] }}
          <span *ngIf="isBroadcastPresetSkipBlocked(option)" class="broadcast-skip-blocked-hint"
            >(broadcast)</span
          >
        </span>
        <span class="duration"> {{ durationFormat(option["duration"]) }}</span>
      </li>


      <li (click)="clearPrerollList()"
          class="clear-preroll-list"

      >
        <i [ngClass]="{ multiple: multiple }">

        </i>
        <span class="clear-prerolls-title">CLEAR PREROLLS</span>
        <span class="duration"> </span>
      </li>


    </ul>
    <span (click)="enabled && toggleList()">
      <i
        [ngClass]="{ 'text-ellipsis': textEllipsis > 0 }"
        [ngStyle]="textEllipsis > 0 && { 'max-width': textEllipsis + 'px' }"
        >{{ value.label }}</i
      >
      <i class="icon-arrow-down"></i>
    </span>
  </section>

  <input type="hidden" [ngModel]="value" placeholder="{{ placeholder }}" />
</div>
